 document.addEventListener('DOMContentLoaded', function() {
  // Slider navigation
  const sliderNav = document.querySelector('.cart-recommendations-slider-nav');
  if (sliderNav) {
    sliderNav.addEventListener('click', function(event) {
      // Prevent event from bubbling up to parent elements
      event.stopPropagation();
      
      const slider = document.querySelector('.cart-recommendations-slider');
      
      if (event.target.classList.contains('cart-recommendation-prev')) {
        event.preventDefault();
        slider.scrollBy({ left: -200, behavior: 'smooth' });
      } 
      else if (event.target.classList.contains('cart-recommendation-next')) {
        event.preventDefault();
        slider.scrollBy({ left: 200, behavior: 'smooth' });
      }
    });
  }
  
  // Handle add to cart functionality for recommendation items
  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('cart-recommendation-add-btn')) {
      event.preventDefault();
      
      const button = event.target;
      const variantId = button.getAttribute('data-variant-id');
      const productTitle = button.getAttribute('data-product-title');
      
      // Update button state
      button.classList.add('loading');
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      
      // Add the item to the cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Show success state
        button.classList.remove('loading');
        button.classList.add('added');
        button.textContent = 'Added!';
        
        // Update free shipping message after adding product
        updateShippingProgress();
        
        // Update cart item count for the "View My Cart" button
        updateCartItemCount();
        
        // Refresh cart drawer content
        refreshCartDrawer();
        
        // Reset button after delay
        setTimeout(() => {
          button.classList.remove('added');
          button.textContent = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        button.classList.remove('loading');
        button.textContent = 'Error';
        
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      });
    }
  });
  
  // Function to update the cart item count in the "View My Cart" button
  function updateCartItemCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemCountElements = document.querySelectorAll('[data-cart-count]');
        
        itemCountElements.forEach(element => {
          element.textContent = cart.item_count;
          
          // If the element was hidden (for zero items), show it now
          if (cart.item_count > 0 && element.classList.contains('hide')) {
            element.classList.remove('hide');
          }
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }
  
  // Function to refresh the entire cart drawer content
  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer')
      .then(response => response.json())
      .then(sections => {
        const parser = new DOMParser();
        const newDrawerContent = parser.parseFromString(sections['cart-drawer'], 'text/html');
        
        // Replace relevant parts of the cart drawer
        const currentDrawer = document.getElementById('CartDrawer');
        
        // Update products container
        updateCartSection(currentDrawer, newDrawerContent, '[data-products]');
        
        // Update subtotal
        updateCartSection(currentDrawer, newDrawerContent, '[data-subtotal]');
        
        // Update recommendations section
        updateCartSection(currentDrawer, newDrawerContent, '.cart-recommendations-slider');
        
        // Show the cart if it was empty before
        const emptyCartElement = currentDrawer.querySelector('.drawer__cart-empty');
        if (emptyCartElement && emptyCartElement.classList.contains('hide') === false) {
          emptyCartElement.classList.add('hide');
        }
        
        // Reinitialize slider functionality if needed
        initializeRecommendationsSlider();
        
        // Update shipping progress after cart refresh
        updateShippingProgress();
        
        // Dispatch a custom event to notify that the cart was updated
        document.dispatchEvent(new CustomEvent('cart:refreshed'));
      })
      .catch(error => console.error('Error refreshing cart drawer:', error));
  }
  
  // Helper function to update a section in the cart drawer
  function updateCartSection(currentDrawer, newDrawerContent, selector) {
    const currentSection = currentDrawer.querySelector(selector);
    const newSection = newDrawerContent.querySelector(selector);
    
    if (currentSection && newSection) {
      // Clear existing content
      while (currentSection.firstChild) {
        currentSection.removeChild(currentSection.firstChild);
      }
      
      // Clone and append new content
      Array.from(newSection.childNodes).forEach(node => {
        currentSection.appendChild(node.cloneNode(true));
      });
      
      // If it's a direct element replacement, also copy attributes
      if (selector !== '[data-products]') {
        // Copy over any attributes from the new section
        Array.from(newSection.attributes).forEach(attr => {
          currentSection.setAttribute(attr.name, attr.value);
        });
      }
    } else if (!currentSection && newSection && currentDrawer) {
      // If the section doesn't exist yet but should (like recommendations after first item)
      const parentSelector = getParentSelector(selector);
      const parent = currentDrawer.querySelector(parentSelector);
      
      if (parent) {
        // Find the new section's container in the new content
        let parentInNew = newDrawerContent.querySelector(parentSelector);
        if (parentInNew) {
          // Find the new section's position in its parent
          const children = Array.from(parentInNew.children);
          const index = children.findIndex(child => child.matches(selector));
          
          if (index !== -1) {
            // Check if we need to insert at a specific position
            if (index < parent.children.length) {
              parent.insertBefore(newSection.cloneNode(true), parent.children[index]);
            } else {
              parent.appendChild(newSection.cloneNode(true));
            }
          }
        }
      }
    }
  }
  
  // Helper function to get parent selector for a given selector
  function getParentSelector(selector) {
    // Common parent containers in cart drawers
    if (selector === '.cart-recommendations-slider') {
      return '.cart-drawer__recommendations';
    }
    // Add more mappings as needed
    return '.cart-drawer__content';
  }
  
  // Initialize recommendations slider
  function initializeRecommendationsSlider() {
    const slider = document.querySelector('.cart-recommendations-slider');
    if (slider) {
      // Any initialization code needed for the slider can go here
      
      // Make sure navigation buttons work with the new slider
      const sliderNavButtons = document.querySelectorAll('.cart-recommendation-prev, .cart-recommendation-next');
      sliderNavButtons.forEach(button => {
        // Remove old event listeners by cloning and replacing
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
      });
    }
  }
  
  // Function to update the shipping progress bar and message in a secure way
  function updateShippingProgress() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const FREE_SHIPPING_THRESHOLD = 6000; // $60.00 in cents
        const container = document.querySelector('[data-free-shipping-message]');
        
        if (container) {
          const cartTotal = cart.total_price;
          const remainingAmount = FREE_SHIPPING_THRESHOLD - cartTotal;
          const progressPercentage = Math.min(100, (cartTotal / FREE_SHIPPING_THRESHOLD) * 100);
          
          // Clear existing content
          while (container.firstChild) {
            container.removeChild(container.firstChild);
          }
          
          if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
            // Create qualified message
            const qualifiedDiv = document.createElement('div');
            qualifiedDiv.className = 'cart-drawer__free-shipping-qualified';
            
            const messageSpan = document.createElement('span');
            messageSpan.textContent = '🎉 Congratulations! You qualify for free shipping!';
            
            qualifiedDiv.appendChild(messageSpan);
            container.appendChild(qualifiedDiv);
          } else {
            // Format the remaining amount as currency without the decimal if it's a whole number
            let formattedAmount = (remainingAmount / 100).toFixed(2);
            if (formattedAmount.endsWith('.00')) {
              formattedAmount = formattedAmount.slice(0, -3);
            }
            
            // Create threshold message
            const thresholdDiv = document.createElement('div');
            thresholdDiv.className = 'cart-drawer__free-shipping-threshold';
            
            const messageSpan = document.createElement('span');
            
            // Create text and strong elements
            const textBefore = document.createTextNode('Spend ');
            const strongElement = document.createElement('strong');
            strongElement.textContent = '$' + formattedAmount;
            const textAfter = document.createTextNode(' more and get free shipping!');
            
            messageSpan.appendChild(textBefore);
            messageSpan.appendChild(strongElement);
            messageSpan.appendChild(textAfter);
            
            thresholdDiv.appendChild(messageSpan);
            
            // Create progress container and bar
            const progressContainer = document.createElement('div');
            progressContainer.className = 'cart-drawer__progress-container';
            
            const progressBar = document.createElement('div');
            progressBar.className = 'cart-drawer__progress-bar';
            progressBar.style.width = progressPercentage + '%';
            
            progressContainer.appendChild(progressBar);
            thresholdDiv.appendChild(progressContainer);
            
            container.appendChild(thresholdDiv);
          }
        }
      })
      .catch(error => console.error('Error updating shipping progress:', error));
  }
  
  // Listen for cart changes
  document.addEventListener('cart:update', function(event) {
    updateShippingProgress();
    updateCartItemCount();
  });
  
  // Observe DOM changes to detect cart item removals
  const cartProductsContainer = document.querySelector('[data-products]');
  if (cartProductsContainer) {
    const observer = new MutationObserver(function(mutations) {
      updateShippingProgress();
      updateCartItemCount();
    });
    
    observer.observe(cartProductsContainer, { 
      childList: true,
      subtree: true
    });
  }
  
  // Run initialization on page load
  updateShippingProgress();
  updateCartItemCount();
  initializeRecommendationsSlider();
  
  // If there's a global window.refreshCart function, update it to use our improved version
  window.refreshCart = function() {
    refreshCartDrawer();
  };
});